<script lang="ts">
	export let text = "";

</script>

<div class="result-icon">
	<slot name="result-icon" />
</div>
<div class="result-text">{text}</div>
<slot />

<style lang="scss">
	.result-icon {
		margin-bottom: 40px;
	}
	.result-text {
		color: white;
		font-size: 1.25rem;
		font-weight: 500;
	}

</style>
